<template>
  <!-- Version 1.2 -->
  <h2>1. Descrição do jogo</h2>
  <p>
    O Highlight Games Soccerbet Game é uma simulação de software exclusiva que utiliza destagues de futebol secionadas
    aleatoriamente de diversas partidas para criar oportnidades de jogo
  </p>
  <h2>2. Descrição e duração do jogo</h2>
  <p>
    Uma única rodada de um jogo de apostas eletrônicas tem entre 3 e 5 minutos de duração. Isso consiste no anúncio do
    jogo, semana do jogo, preâmbulo, exibição no jogo e resultados. A exibição no jogo terá 1 minuto de duração. Uma
    temporada inteira pode durar de 78 a 190 minutos para ser concluída. Isso se deve ao número de equipes nessa liga
    específica; portanto, o número de semanas de jogo varia. Uma seleção de eventos de futebol de destaque é
    estatisticamente independente, aleatória e imprevisível, e é gerada pelo Gerador de Números Aleatórios (RNG).
  </p>
  <h2>3. Mercados de apostas</h2>
  <h3>3.1 Objetivos exatos</h3>
  <p>
    O significado da aposta de número exato de gols é que um número exato de gols deve ser marcado em uma única partida.
    Portanto, essa variação de aposta significa que você deve prever um número exato de gols, apesar do resultado final
    de uma partida inteira.
  </p>
  <h3>3.2 Gols exatos do time da casa</h3>
  <p>Uma aposta no número exato de gols que o time da casa marcará no jogo.</p>
  <h3>3.3 Gols exatos da equipe visitante</h3>
  <p>Uma aposta no número exato de gols que o time visitante marcará no jogo.</p>
  <h3>3.4 Ambas as equipes marcam gols</h3>
  <p>
    Ambas as equipes precisam marcar pelo menos um gol, tornando qualquer resultada de 1 a 1 ou mais numa aposta
    vencedora. A aposta &quot;Ambas as equipes marcarão&quot; dá aos apostadores a chance de tirar vantagem desses
    eventos, a fim de obter probabilidades lucrativas, quando apenas uma das duas equipes conseguir marcar. 3,5
    Pontuação correta O placar correto é apostar no que você acha que será o resultado final de uma partida de futebol.
    Com um máximo de 6 gols em um jogo, há 28 resultados possíveis.,
  </p>
  <h3>3.6 Dupla chance</h3>
  <p>
    Uma aposta de chance dupla permite que você cubra dois dos três resultados possíveis em uma partida de futebol com
    uma aposta. Time da casa e empate - Sua aposta será vencedora se o time da casa vencer ou empatar a partida. Time
    visitante e empate - Sua aposta será vencedora se o time visitante vencer ou empatar a partida.
  </p>
  <h3>3.7 Resultado da partida (1X2)</h3>
  <p>Uma aposta na vitória do time da casa (1), na vitória do time visitante (2) ou em um empate (X).</p>
  <h3>3.8 Resultado da partida e ambas as equipes marcarão gols (1X2 + BTTS)</h3>
  <p>
    Uma aposta no resultado da partida (1 é vitória do time da casa, X é empate, 2 é vitória do time visitante) e se
    ambos os times marcam ou não.
  </p>
  <ul>
    <li>1 + Gol - O time da casa vence e ambos os times marcam pelo menos um gol [por exemplo, 3-1].</li>
    <li>1 + Nenhum gol - O time da casa vence e é o único time a marcar um gol [por exemplo, 1-0].</li>
    <li>X + Gol - Aposte em um empate e no placar de ambos os times. [por exemplo, 1-1, 2-2].</li>
    <li>X + Sem gol - Aposte em um empate sem que nenhuma equipe marque. [Apenas 0-0].</li>
    <li>2 + Gol - O time visitante vence e ambos os times marcam pelo menos um gol [por exemplo, 1-2, 1-3].</li>
    <li>2 + Nenhum gol - O time visitante vence e é o único time a marcar gols [por exemplo, 0-1, 0-2].</li>
  </ul>
  <h3>3.9 Resultado da partida e gols acima/abaixo de 1,5</h3>
  <p>Uma aposta no resultado da partida de 1X2 e o número total de gols será inferior ou superior a 1,5 gols.</p>
  <h3>3.10 Resultado da partida e acima/abaixo de 2,5 gols</h3>
  <p>
    Uma aposta no resultado da partida de 1X2 e no número total de gols sera interiour ou superior a 2,5 gols. 3,11
    Total de metas (1 a 2, 1 a 3, 1 a 4, 2 a 3, 2 a 4) Uma aposta em que o jogo terá um total de 1 a 2, 1 a 3, 1 a 4, 2
    a 3 ou 2 a 4 gols como resultado final. Essa é uma aposta de SIM ou NÃO.
  </p>
  <h3>3.12 Acima/Abaixo de 1,5 gols do time da casa</h3>
  <p>Uma aposta em que o time da casa marcará mais ou menos de 1,5 gol na partida.</p>
  <h3>3.13 Acima/Abaixo de 1,5 gols do time visitante</h3>
  <p>Uma aposta em que o time visitante marcará mais ou menos de 1,5 gol na partida.</p>
  <h3>3.14 Acima/Abaixo de 1,5, 2,5, 3,5, 4,5 Total de gols</h3>
  <p>
    Uma aposta no número total de gols marcados por ambas as equipes que será inferior ou superior a 1,5, 2,5, 3,5 ou
    4,5 na partida.
  </p>
</template>
